import { connect } from 'react-redux';
import * as actions from 'embed/actions';
import reducers from 'embed/reducers';
import TimedOverlay from 'embed/components/TimedOverlay'

export default connect(reducers, actions)(TimedOverlay);
